
export const MaterialTypeConstant = {
    materialType: 'api/MaterialType',   
    materialTypeRoute: 'materialType',
    manageMaterialTypeRoute: 'manageMaterialType',
    bulkInsertMessage:'Material types are successfully importd',
    searchFieldName: 'name',
    code: 'code',
};